// extracted by css-extract-rspack-plugin
export default {"desktop-navigation":"DesktopNavigation_desktop-navigation__miZbR"};